import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";
import { getUserInfo } from "@/api/home/index.js";
import store from "@/store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "root",
    redirect: "/homeview",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/Login.vue"),
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/homeview",
        name: "HomeView",
        component: () => import("@/views/HomeView/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === "/homeview") {
    const res = await getUserInfo();
    if (res.code === 200) {
      store.commit("setUserInfo", res?.data || null);
      next();
    } else {
      // if (process.env.NODE_ENV !== "production") return;
      window.location.href = window.g.base_url + window.g.loginUrl;
    }
  } else {
    next("/homeview");
  }
});

export default router;
